<template>
  <v-container fluid>
    <v-row>
      <v-col sm="12">
        <h2 class="font-weight-thin">Optional Release Notes Marked for Implement Later</h2>
        <v-divider class="my-3"></v-divider>
        <v-data-table
          :headers="headers"
          :hide-default-footer="true"
          :items="list"
          disable-pagination
          must-sort
          no-data-text="No release notes marked 'Implement Later'"
        >
          <template v-slot:item="{ item }">
            <tr
              class="widgetImplementLaterList__item"
              @click="
                $router.push({
                  name: 'testPlanView',
                  params: {
                    packId: item.packId,
                    releaseNoteId: item.releaseNoteId,
                    serviceAreaId: serviceAreaId,
                  },
                })
              "
              data-cy="widgetImplementLaterList__item"
            >
              <td data-cy="widgetImplementLaterList__item--titleId">{{ item.title }} (ID:{{ item.releaseNoteId }})</td>
              <td data-cy="widgetImplementLaterList__item--summary">
                <v-tooltip v-if="item.summary" top max-width="420">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">{{ truncate(stripHtmlTags(item.summary)) }}</div>
                  </template>
                  <span v-html="item.summary"></span>
                </v-tooltip>
              </td>
              <td data-cy="widgetImplementLaterList__item--packTitle">{{ item.packTitle }}</td>
              <td data-cy="widgetImplementLaterList__item--implementationStatus">
                {{ item.implementationStatus }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { truncate, stripHtmlTags } from "@/lib/summaryFormatters";

import testPlanApi from "../../api/testPlan";

export default {
  computed: {
    ...mapState({
      serviceAreaId: state => state.session.serviceArea,
    }),
  },
  async created() {
    const response = await testPlanApi.search({
      operator: "AND",
      list: [
        {
          comparator: "=",
          term: "serviceAreaId",
          value: this.serviceAreaId,
        },
        {
          comparator: "=",
          term: "memberTestPlan.implementLater",
          value: true,
        },
      ],
    });
    this.list = response.data.result;
  },
  methods: {
    truncate,
    stripHtmlTags,
  },
  data: () => ({
    list: [],
    headers: [
      {
        modifier: "titleId",
        text: "Release Note Title/ID",
        value: "title",
      },
      {
        modifier: "summary",
        text: "Summary",
        sortable: false,
      },
      {
        modifier: "cycleIndicated",
        text: "Release Cycle When Indicated",
        value: "packTitle",
      },
      {
        modifier: "implementationStatus",
        text: "Implementation Status",
        value: "implementationStatus",
      },
    ],
  }),
};
</script>

<style>
.widgetImplementLaterList__item {
  cursor: pointer;
}
</style>
